import React, { useState } from "react";
import "./LiveTimeLabel.scss";
import { LiveTimeLabelForEntriesProps } from "./LiveTimeLabelForEntries.Interface";
import nameof from "ts-nameof.macro";
import { useCompressedTimeEntryTime } from "./useCompressedTimeEntryTime";
import { v4 } from "uuid";

export const LiveTimeLabelForEntries = (props: LiveTimeLabelForEntriesProps) => {
	const [source] = useState(() => `${nameof(LiveTimeLabelForEntries)}_${v4()}`);
	const { totalTime, timeUnitIndicator } = useCompressedTimeEntryTime(props.compressedTimeEntry, source);

	return (
		<>
			<span className="total-time">{totalTime}</span>
			<span className="time-unit-indicator">{timeUnitIndicator}</span>
		</>
	);
};
